import Core                             from "@/core/Core";
import TenderParticipationRequestsDAO   from "@/domains/TenderParticipationRequest/TenderParticipationRequestsDAO";
import TenderParticipationRequest       from "@/domains/TenderParticipationRequest/TenderParticipationRequest";

class TenderParticipationRequestsService {

    /**
     * Запросы на участие по тендеру.
     * Тендер обязателен, партнёр и товар — необязательные уточнения.
     */
    static async getList(
      tenderId: number,
      filters?: Parameters<typeof TenderParticipationRequestsDAO.getList>[1]
    ): Promise<TenderParticipationRequest[]> {
        const response = await TenderParticipationRequestsDAO.getList(tenderId, filters);

        return Core.utils.hydrateArray(response.data, TenderParticipationRequest.fromServer);
    }

    /**
     * Отправить запрос на участие в тендере
     */
    static async send(tenderParticipationRequest: TenderParticipationRequest): Promise<boolean> {
        const response = await TenderParticipationRequestsDAO.send(tenderParticipationRequest);

        if (response.ok) {
            Core.showNotification.success('Запрос на участие отправлен');
        }
        else {
            Core.showNotification.error('Ошибка при отправке запроса на участие');
        }

        return response.ok;
    }
}

export default TenderParticipationRequestsService;
